import { axios } from '@ben/api/axios';
import type { BenLanguageCode } from '@ben/common/languages';
import type { IUser } from '../../types/user';

export const getMe: () => Promise<IUser> = async (): Promise<IUser> => {
  const response = await axios.get('me/');
  return response.data as IUser;
};

export const updateUserLanguage: (
  language: BenLanguageCode
) => Promise<IUser> = async (language: BenLanguageCode): Promise<IUser> => {
  const response = await axios.patch('me/', { preferredLanguage: language });
  return response.data as IUser;
};
